import { useMemo } from "react";
import { Path, Shape } from "three";
import { degToRad } from "three/src/math/MathUtils";

const RoundedRectLineGeometry = ({
  innerRadius = 0.25,
  lineWidth = 0.02,
  lenght = 2,
  width = 1,
  curveSegments = 6,
  ...props
}) => {
  const shape = useMemo(() => {
    const shape = new Shape();
    const outerRadius = innerRadius + lineWidth;
    const flatSideLength = lenght - 2 * innerRadius;
    const halfSideLength = flatSideLength / 2;
    const flatSideWidth = width - 2 * innerRadius;
    const halfSideWidth = flatSideWidth / 2;

    shape.moveTo(-lenght / 2, halfSideWidth);
    // shape.lineTo(-halfSideLength, lenght / 2);
    shape.absarc(-halfSideLength, halfSideWidth, outerRadius, degToRad(180), degToRad(90), true);
    shape.lineTo(halfSideLength, width / 2 + lineWidth);
    shape.absarc(halfSideLength, halfSideWidth, outerRadius, degToRad(90), degToRad(0), true);
    shape.lineTo(lenght / 2 + lineWidth, -halfSideWidth);
    shape.absarc(halfSideLength, -halfSideWidth, outerRadius, degToRad(0), degToRad(270), true);
    shape.lineTo(-halfSideLength, -width / 2 - lineWidth);
    shape.absarc(-halfSideLength, -halfSideWidth, outerRadius, degToRad(270), degToRad(180), true);

    shape.closePath();

    const innershape = new Path();
    // const outerRadius = innerRadius + lineWidth;
    const innerflatSideLength = lenght - 2 * innerRadius;
    const innerhalfSideLength = innerflatSideLength / 2;
    const innerflatSideWidth = width - 2 * innerRadius;
    const innerhalfSideWidth = innerflatSideWidth / 2;

    innershape.moveTo(-lenght / 2, innerhalfSideWidth);
    // innershape.lineTo(-innerhalfSideLength, lenght / 2);
    innershape.absarc(-innerhalfSideLength, innerhalfSideWidth, innerRadius, degToRad(180), degToRad(90), true);
    innershape.lineTo(innerhalfSideLength, width / 2);
    innershape.absarc(innerhalfSideLength, innerhalfSideWidth, innerRadius, degToRad(90), degToRad(0), true);
    innershape.lineTo(lenght / 2, -innerhalfSideWidth);
    innershape.absarc(innerhalfSideLength, -innerhalfSideWidth, innerRadius, degToRad(0), degToRad(270), true);
    innershape.lineTo(-innerhalfSideLength, -width / 2);
    innershape.absarc(-halfSideLength, -innerhalfSideWidth, innerRadius, degToRad(270), degToRad(180), true);

    innershape.closePath();

    shape.holes.push(innershape);

    return shape;
  }, [innerRadius, lenght, width, curveSegments]);

  return <shapeGeometry center={true} args={[shape, curveSegments]} />;
};

export default RoundedRectLineGeometry;
